module.exports = __webpack_public_path__ + "static/media/work.bced6a37.svg";